import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=537df3d2&scoped=true"
import script from "./TagSelector.vue?vue&type=script&lang=js"
export * from "./TagSelector.vue?vue&type=script&lang=js"
import style0 from "./TagSelector.vue?vue&type=style&index=0&id=537df3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537df3d2",
  null
  
)

export default component.exports